import { Chip, Divider, LinearProgress, Stack, Typography } from "@mui/material"
import { useEffect, useState } from "react"
import getDomain from "./domain"
import { DataGridPro } from "@mui/x-data-grid-pro"



export default function SeedboxStatus() {

    const [freeSpace, setFreeSpace] = useState(0)
    const [driveCapacity, setDriveCapacity] = useState(0)

    const [rows, setRows] = useState([])

    const columns = [
        { field: 'id' },
        { field: 'name', headerName: "Listing Name", flex: 1 },
        {
            field: 'percentDone',
            headerName: "Progress",
            flex: 1,
            renderCell: (v) => { return <LinearProgress sx={{width: '100%'}} variant="determinate" value={v.value*100} />}
        },
        { field: 'downloadedEver', headerName: "Downloaded", flex: 1, renderCell: (v) => `${(v.value/1024/1024/1024).toFixed(2)} GB (${(v.row.percentDone*100).toFixed(2)}%)` },
        {
            field: 'sizeWhenDone',
            headerName: "Size",
            width: 120,
            renderCell: (v) => {
                const sizeGB = (v.value / 1073741824).toFixed(2)
                if (sizeGB > 50) { return <Chip label={sizeGB + " GB"} color='error'/> }
                if (sizeGB > 20) { return <Chip label={sizeGB + " GB"} color='warning'/> }
                if (sizeGB < 20.1) { return <Chip label={sizeGB + " GB"} color='success'/> }
                else { return <Chip label={sizeGB + " GB"} /> }
            }
        },
        { field: 'peersConnected', headerName: "Peers", width: 90},
    ]


    const getSpace = async () => {
        const res = await fetch(`${getDomain()}/storage`)
        const json = await res.json()

        const { free, size } = json

        setFreeSpace(free/1073741824)
        setDriveCapacity(size/1073741824)

    }

    const loop = async () => {
        await getActiveTorrents()
        await getSpace()
    }


    const getActiveTorrents = async () => {
        try {
            const res = await fetch(`${getDomain()}/status`)
            const json = await res.json()
            setRows(json.active.torrents)
            //console.log("ACTIVE", json)
        } catch (error) {

        }
    }




    useEffect(() => {
        loop().catch((e) => console.log(e))
      const interval = setInterval(() => {
        loop().catch((e) => console.log(e))
      }, 2000)

      return () => clearInterval(interval)
    }, [])


    return (
        <Stack>
            
            <Typography variant="h4">Active Torrents</Typography>
            <Divider sx={{marginTop: 1}}/>
            <br></br>
            <DataGridPro 
                columns={columns}
                rows={rows}
                initialState={{
                    columns: {
                      columnVisibilityModel: {
                        // Hide columns status and traderName, the other columns will remain visible
                        id: false,
                      },
                    },
                  }}
            />
            <br></br>
            <br></br>
            <Typography variant="h4">Storage</Typography>
            <Divider sx={{marginTop: 1}}/>
            <br></br>
            <LinearProgress sx={{height: '20px'}} variant="determinate" value={100-(freeSpace/driveCapacity)*100} />
            <Typography variant="p">{freeSpace.toFixed(2)} GB / {driveCapacity.toFixed(2)} GB | {(100-(freeSpace/driveCapacity)*100).toFixed(2)}% Used</Typography>
        </Stack>
    )
}

